$(document).ready( function() {
	$('.js-tabs').on('click', 'li:not(.active)', function() {
		const _this = $(this);
		console.log('.js-tabs li:not(.active) --- click');
		// const currentTab = _this.parents('.tabs').find('.tab').eq(_this.index());
		const clickMinusIndex = $(_this).prevAll().filter((index,item)=>item.tagName!=="LI").length || 0;
		const currentTab = _this.closest('.tabs').find('.tab').eq(_this.index()-clickMinusIndex);
		console.log('_this = ',_this);
		console.log('currentTab = ',currentTab);
		console.log('currentTab.siblings(\'.tab\') = ',currentTab.siblings('.tab'));
		let ww = $(window).width();
		let marginOffset = 0;
		// let parentTab = _this.parents('.tabs');

		// для скролла к элементу в адаптиве
		const itemOuterWidth = _this.outerWidth(); // узнаем ширину текущего элемента (width + padding)
		const itemOffsetLeft = _this.offset().left; // узнаем значение отступа слева в контейнере у текущего элемента
		const containerScrollLeft = _this.parents('.js-tabs').scrollLeft(); // узнаем текущее значение скролла
		const containerOuterWidth = _this.parents('.js-tabs').outerWidth(); // узнаем ширину контейнера (width + padding)
		const positionCetner = (containerOuterWidth / 2 - itemOuterWidth / 2); // рассчитываем позицию центра
		const scrollLeftUpd = containerScrollLeft + itemOffsetLeft - positionCetner; // рассчитываем положение скролла относительно разницы отступа элемента и центра контейнера

		_this.addClass('active').siblings().removeClass('active');
		// parentTab.addClass('trigger_case');

		// setTimeout(function() {
		// 	if (parentTab.hasClass('trigger_case')) {
		// 		parentTab.removeClass('trigger_case');
		// 	}
		// }, 1000);

		currentTab.siblings('.tab').hide();
		currentTab.fadeIn(750);

		if (currentTab.find('.cases-filter__list li.active').length < 1) {
			currentTab.find('.cases-filter__list li').eq(0).click();
		}

		// анимируем
		_this.parents('.js-tabs:not(.services-tabs__head)').animate({
			scrollLeft: scrollLeftUpd
		}, 400);

		if (ww > 767 && ww < 1025) {
			marginOffset = 300;
		}

		// анимируем
		_this.parents('.js-tabs.services-tabs__head').animate({
			scrollLeft: scrollLeftUpd - marginOffset
		}, 400);

		if (_this.parents('.js-tabs').hasClass('js-tabsCases')) {
			_this.parents('.js-tabs').addClass('disabled');

			setTimeout(function() {
				if ($('.filter_integrator.active').length > 0) {
					$('.tab').eq(1).find('li:first-child').click();

					$('.filter_agency li').removeClass('active');
				}

				if ($('.filter_agency.active').length > 0) {
					$('.tab').eq(0).find('li:first-child').click();

					$('.filter_integrator li').removeClass('active');
				}

				_this.parents('.js-tabs').removeClass('disabled');

				$('.js-filterCase').animate({
					scrollLeft: 0
				}, 500);

				initCases();

			}, 100)
		}
	})

	$('.js-tabLink').on('click', function () {
		if ($(window).width() < 1270) {
			if ($(this).hasClass('is-show')) {
				$(this).toggleClass('is-show');
				$(this).find('.collapse').slideUp(500);
			} else {
				$(this).addClass('is-show').siblings().removeClass('is-show');
				$('.collapse').slideUp();
				$(this).find('.collapse').slideDown(500);
			}
		}
	})
});
